import axios from 'axios'
import {config} from '../../config'


export default class OnlineFormServices {

  getLogin() {
     return axios.post(config.baseUrl+'/login',{
	    'promoId': window.mepaConfig.promoId
	  });
  }
  
  postPersistResponse(token, data){
  	  let url = config.baseUrl+'/persistResponse';
  	  return this.doPOST(url, token, data);
  }
  
  postSerbiaPersistResponse(token, data){
      let url = config.baseUrl+'/quiz/persistResponse';
      return this.doPOST(url, token, data);
  }

  postDrawPersistResponse(token, data){
      let url = config.baseUrl+'/draw/persistResponse';
      return this.doPOST(url, token, data);
  }

  postRedemptionResponse(token, data){
      let url = config.baseUrl+'/redemptionResponse';
      return this.doPOST(url, token, data);
  }
  
  doPOST(url, token, data) {
     return axios.post(url,data,{
       headers:{
        'Content-Type':'application/json',
        'Authorization':'Bearer ' + token}
      });
  }
}




// WEBPACK FOOTER //
// ./src/online-form/services/OnlineFormServices.js